<div class="reset-container">
  <div class="row" style="height: 100%; padding: 120px 0;">
    <div
      class="col-sm-10 col-md-6 col-lg-4"
      style="margin: 0 auto;"
    >
      <div class="canLoadForm"
        *ngIf="canLoadForm"
        style="background-color: #fff; padding: 16px;"
      >
        <div class="row">
          <div class="col-sm-12 center-sm" >
            <!-- <img
              src="./assets/images/index-logo.png"
              style="max-width: 100px;"
              alt=""
            /> -->
            <h2 style="margin-bottom: 8px; margin-top: 16px;">
              {{ "RESET_PASS.UPDATE_PASS" | translate}}
            </h2>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">

              <mat-form-field class="col-sm-12" appearance="outline">
                <mat-label>{{ "RESET_PASS.PASSWORD" | translate}}</mat-label>
                <input matInput type="password" formControlName="newPassword" />
              </mat-form-field>
              <div *ngIf="form.get('newPassword').errors?.pattern">
                <p style="color: red;text-align: start;margin:0 0 10px 0 !important;font-size: 13px">{{"COMMON.PASSWORD_COMPLEXTY"|translate}}</p>
              </div>

              <mat-form-field class="col-sm-12" appearance="outline">
                <mat-label>{{ "RESET_PASS.CONFIRM_PASS" | translate}}</mat-label>
                <input matInput type="password" formControlName="confirmPassword" />
              </mat-form-field>
              <div *ngIf="form.get('confirmPassword').errors?.pattern" >
                <p style="color: red;text-align: start;margin:0 0 10px 0  !important;font-size: 13px">{{"COMMON.PASSWORD_COMPLEXTY"|translate}}</p>
              </div>
              <div *ngIf="form.get('confirmPassword').errors?.mustMatch" >
                <p style="color: red;text-align: start;margin:0 0 10px 0  !important;font-size: 13px">{{"COMMON.PASSWORD_NOT_IDENTICAL"|translate}}</p>
              </div>

              <div>
                <button
                  mat-raised-button
                  type="submit"
                  color="primary"
                  style="width: 100%;" [disabled]="form?.invalid"
                >
                  <span>{{ "RESET_PASS.RESET_BUTTON" | translate}}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
